// @ts-nocheck
type Theme = {
  background0: string;
  background025: string;
  background05: string;
  background075: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
  color10: string;
  color11: string;
  color12: string;
  color13: string;
  color0: string;
  color025: string;
  color05: string;
  color075: string;
  background: string;
  backgroundHover: string;
  backgroundPress: string;
  backgroundFocus: string;
  borderColor: string;
  borderColorHover: string;
  borderColorPress: string;
  borderColorFocus: string;
  color: string;
  colorHover: string;
  colorPress: string;
  colorFocus: string;
  colorTransparent: string;
  placeholderColor: string;
  outlineColor: string;
  textSecondary: string;
  backgroundSecondary: string;
  backgroundTertiary: string;
  groupedPrimary: string;
  groupedSecondary: string;
  strokePrimary: string;
  cream1: string;
  cream2: string;
  cream3: string;
  cream4: string;
  cream5: string;
  cream6: string;
  cream7: string;
  cream8: string;
  cream9: string;
  cream10: string;
  cream11: string;
  cream12: string;
  cream13: string;
  gray1: string;
  gray2: string;
  gray3: string;
  gray4: string;
  gray5: string;
  gray6: string;
  gray7: string;
  gray8: string;
  gray9: string;
  gray10: string;
  gray11: string;
  gray12: string;
  gray13: string;
  green1: string;
  green2: string;
  green3: string;
  green4: string;
  green5: string;
  green6: string;
  green7: string;
  green8: string;
  green9: string;
  green10: string;
  green11: string;
  green12: string;
  green13: string;
  lightblue1: string;
  lightblue2: string;
  lightblue3: string;
  lightblue4: string;
  lightblue5: string;
  lightblue6: string;
  lightblue7: string;
  lightblue8: string;
  lightblue9: string;
  lightblue10: string;
  lightblue11: string;
  lightblue12: string;
  lightblue13: string;
  limegreen1: string;
  limegreen2: string;
  limegreen3: string;
  limegreen4: string;
  limegreen5: string;
  limegreen6: string;
  limegreen7: string;
  limegreen8: string;
  limegreen9: string;
  limegreen10: string;
  limegreen11: string;
  limegreen12: string;
  limegreen13: string;
  navy1: string;
  navy2: string;
  navy3: string;
  navy4: string;
  navy5: string;
  navy6: string;
  navy7: string;
  navy8: string;
  navy9: string;
  navy10: string;
  navy11: string;
  navy12: string;
  navy13: string;
  orange1: string;
  orange2: string;
  orange3: string;
  orange4: string;
  orange5: string;
  orange6: string;
  orange7: string;
  orange8: string;
  orange9: string;
  orange10: string;
  orange11: string;
  orange12: string;
  orange13: string;
  red1: string;
  red2: string;
  red3: string;
  red4: string;
  red5: string;
  red6: string;
  red7: string;
  red8: string;
  red9: string;
  red10: string;
  red11: string;
  red12: string;
  red13: string;
  shadowColor: string;
  shadowColorHover: string;
  shadowColorPress: string;
  shadowColorFocus: string;
  navy: string;
  lightblue: string;
  cream: string;
  limegreen: string;
  strokeSecondary: string;
  strokeTertiary: string;
  textTertiary: string;
  textDefault: string;
  textSubtle: string;
  textMuted: string;
  textInverse: string;
  textBrand: string;
  textBrandStrong: string;
  textAccent: string;
  textAccentStrong: string;
  textPositive: string;
  textPositiveStrong: string;
  textNegative: string;
  textNegativeStrong: string;
  textWarning: string;
  textWarningStrong: string;
  iconDefault: string;
  iconSubtle: string;
  iconMuted: string;
  iconInverse: string;
  iconBrand: string;
  iconBrandStrong: string;
  iconAccent: string;
  iconAccentStrong: string;
  iconPositive: string;
  iconPositiveStrong: string;
  iconNegative: string;
  iconNegativeStrong: string;
  iconWarning: string;
  iconWarningStrong: string;
  borderDefault: string;
  borderDefaultHover: string;
  borderStrong: string;
  borderStrongHover: string;
  borderIntense: string;
  borderIntenseHover: string;
  borderInverse: string;
  borderBrand: string;
  borderBrandHover: string;
  borderBrandStrong: string;
  borderBrandStrongHover: string;
  borderAccent: string;
  borderAccentHover: string;
  borderAccentStrong: string;
  borderAccentStrongHover: string;
  borderPositive: string;
  borderPositiveHover: string;
  borderPositiveStrong: string;
  borderPositiveStrongHover: string;
  borderNegative: string;
  borderNegativeHover: string;
  borderNegativeStrong: string;
  borderNegativeStrongHover: string;
  borderWarning: string;
  borderWarningHover: string;
  borderWarningStrong: string;
  borderWarningStrongHover: string;
  bgBrand: string;
  bgBrandHover: string;
  bgBrandStrong: string;
  bgBrandStrongHover: string;
  bgAccent: string;
  bgAccentHover: string;
  bgAccentStrong: string;
  bgAccentStrongHover: string;
  bgPositive: string;
  bgPositiveHover: string;
  bgPositiveStrong: string;
  bgPositiveStrongHover: string;
  bgNegative: string;
  bgNegativeHover: string;
  bgNegativeStrong: string;
  bgNegativeStrongHover: string;
  bgWarning: string;
  bgWarningHover: string;
  bgWarningStrong: string;
  bgWarningStrongHover: string;
  surface0: string;
  surface0Hover: string;
  surface1: string;
  surface1Hover: string;
  surface2: string;
  surface2Hover: string;
  surfaceStrong: string;
  surfaceStrongHover: string;
  bgDisabled: string;
  bgDisabledSubtle: string;
  utilityStar: string;
  utilityGrellow: string;
  utilityOverlayDark: string;
  utilityOverlayMedium: string;
  utilityOverlayLight: string;

}

function t(a: [number, number][]) {
  let res: Record<string,string> = {}
  for (const [ki, vi] of a) {
    res[ks[ki] as string] = colors[vi] as string
  }
  return res as Theme
}
export const colors = [
  'hsla(0, 0%, 100%, 0)',
  'hsla(0, 0%, 100%, 0.25)',
  'hsla(0, 0%, 100%, 0.5)',
  'hsla(0, 0%, 100%, 0.75)',
  'hsl(0, 0%, 100%)',
  'hsl(40, 60%, 99.02%)',
  'hsl(36, 55.56%, 96.47%)',
  'hsl(36, 50%, 96.08%)',
  'hsl(42, 29.41%, 93.33%)',
  'hsl(36.92, 11.3%, 77.45%)',
  'hsl(218.01, 10.4%, 62.38%)',
  'hsl(217.9, 20.15%, 47.65%)',
  'hsl(218.24, 43.54%, 33.24%)',
  'hsl(219.38, 100%, 18.82%)',
  'hsl(36, 2.56%, 38.24%)',
  'hsl(228, 61.64%, 14.31%)',
  'hsla(219.38, 100%, 18.82%, 0)',
  'hsla(219.38, 100%, 18.82%, 0.25)',
  'hsla(219.38, 100%, 18.82%, 0.5)',
  'hsla(219.38, 100%, 18.82%, 0.75)',
  '#EAE7E1',
  '#CBC7C0',
  '#3D3B38',
  '#2A2926',
  'hsl(223.81, 0%, 100%)',
  'hsl(35.98, 55.7%, 99.6%)',
  'hsl(35.99, 55.67%, 98.98%)',
  'hsl(35.99, 55.64%, 98.23%)',
  'hsl(35.99, 55.6%, 97.39%)',
  'hsl(36, 22.32%, 90.03%)',
  'hsl(36, 14.64%, 83.69%)',
  'hsl(36, 11.28%, 77.45%)',
  'hsl(36.01, 7.63%, 65.3%)',
  'hsl(36.01, 6.22%, 57.04%)',
  'hsl(36.01, 1.79%, 48.38%)',
  'hsl(36.04, 7.67%, 26.52%)',
  'hsl(223.81, 0%, 98.71%)',
  'hsl(223.81, 0%, 96.69%)',
  'hsl(223.81, 0%, 94.28%)',
  'hsl(223.81, 0%, 91.57%)',
  'hsl(223.81, 0%, 88.63%)',
  'hsl(223.81, 0%, 82.78%)',
  'hsl(223.81, 0%, 77.01%)',
  'hsl(223.81, 0%, 71.32%)',
  'hsl(223.81, 0%, 60.2%)',
  'hsl(223.81, 0%, 52.62%)',
  'hsl(223.81, 0%, 44.21%)',
  'hsl(223.81, 0%, 24.44%)',
  'hsl(136.74, 86.72%, 98.03%)',
  'hsl(137.32, 85.98%, 94.88%)',
  'hsl(138.1, 85.17%, 90.94%)',
  'hsl(139.12, 84.37%, 86.27%)',
  'hsl(140.49, 83.67%, 80.78%)',
  'hsl(140.77, 70.06%, 73.76%)',
  'hsl(141.11, 60.58%, 67.19%)',
  'hsl(141.49, 54.35%, 60.68%)',
  'hsl(142.52, 47.08%, 48.55%)',
  'hsl(143.56, 58.97%, 40.26%)',
  'hsl(145.38, 20.72%, 39.02%)',
  'hsl(154.32, 100%, 7.32%)',
  'hsl(198.25, 100%, 98.36%)',
  'hsl(198.17, 100%, 95.77%)',
  'hsl(198.06, 100%, 92.59%)',
  'hsl(197.91, 100%, 88.9%)',
  'hsl(197.69, 100%, 84.71%)',
  'hsl(197.65, 81.32%, 78.57%)',
  'hsl(197.59, 68.54%, 72.62%)',
  'hsl(197.53, 60.36%, 66.74%)',
  'hsl(197.37, 47.47%, 55.42%)',
  'hsl(197.21, 45.32%, 47.71%)',
  'hsl(196.93, 17.13%, 41.59%)',
  'hsl(194.54, 100%, 17.67%)',
  'hsl(81.37, 80.34%, 98.06%)',
  'hsl(80.98, 79.85%, 95%)',
  'hsl(80.49, 79.31%, 91.25%)',
  'hsl(79.89, 78.76%, 86.9%)',
  'hsl(79.17, 78.26%, 81.96%)',
  'hsl(79.02, 62.98%, 74.46%)',
  'hsl(78.85, 53.39%, 67.56%)',
  'hsl(78.66, 47.22%, 60.75%)',
  'hsl(78.19, 40.45%, 48.36%)',
  'hsl(77.74, 50%, 40.06%)',
  'hsl(77.04, 16.19%, 41%)',
  'hsl(72.49, 100%, 9.43%)',
  'hsl(217.64, 28.4%, 90.23%)',
  'hsl(217.67, 27.55%, 75.29%)',
  'hsl(217.79, 26.38%, 57.84%)',
  'hsl(218.13, 39.03%, 38.91%)',
  'hsl(220.31, 100%, 18.76%)',
  'hsl(221.56, 100%, 18.52%)',
  'hsl(223.19, 100%, 18.46%)',
  'hsl(227.94, 100%, 18.08%)',
  'hsl(232.66, 100%, 17.99%)',
  'hsl(238.08, 95%, 6.81%)',
  'hsl(249.82, 100%, 10.51%)',
  'hsl(25.41, 98.66%, 97.62%)',
  'hsl(25.53, 97.04%, 93.85%)',
  'hsl(25.69, 95.18%, 89.23%)',
  'hsl(25.9, 93.19%, 83.89%)',
  'hsl(26.21, 91.15%, 77.84%)',
  'hsl(26.28, 82.85%, 72.28%)',
  'hsl(26.36, 74.38%, 66.83%)',
  'hsl(26.45, 68.27%, 61.43%)',
  'hsl(26.71, 56.23%, 50.89%)',
  'hsl(26.99, 64.42%, 43.64%)',
  'hsl(27.52, 24.99%, 36.97%)',
  'hsl(31.22, 100%, 14.55%)',
  'hsl(2.41, 100%, 97.74%)',
  'hsl(2.13, 100%, 94.09%)',
  'hsl(1.69, 100%, 89.48%)',
  'hsl(1.03, 97.78%, 84.05%)',
  'hsl(0, 91.15%, 77.84%)',
  'hsl(359.8, 90.11%, 74.56%)',
  'hsl(359.58, 83.91%, 70.72%)',
  'hsl(359.31, 79%, 66.88%)',
  'hsl(358.63, 65.23%, 58.15%)',
  'hsl(357.96, 57.5%, 51.87%)',
  'hsl(356.86, 26.63%, 33.91%)',
  'hsl(348.14, 100%, 21.78%)',
  'rgba(75, 68, 43, 0.10)',
  'rgba(75, 68, 43, 0.05)',
  '#002160',
  '#B1E8FF',
  '#FBF7F1',
  '#DEF5AD',
  '#EBE7E0',
  '#ADA8A0',
  '#7A766F',
  '#BBB6AE',
  '#FFFFFF',
  '#54A714',
  '#3A5E1A',
  '#0E74B0',
  '#093654',
  '#4E7C23',
  '#284213',
  '#C42020',
  '#651010',
  '#C96200',
  '#6B2B05',
  '#98938B',
  '#C3F555',
  '#8EE23F',
  '#72C828',
  '#66C3F5',
  '#38AAEC',
  '#0B5C8E',
  '#0A476E',
  '#F98B8B',
  '#F05252',
  '#A81A1A',
  '#881414',
  '#FFB96A',
  '#FCA92C',
  '#A84A00',
  '#8F3C06',
  '#EFFAD6',
  '#DAF997',
  '#E6F6FF',
  '#DFF4FF',
  '#1490D4',
  '#FFF0EF',
  '#FFD9D9',
  '#E03030',
  '#FFEFDE',
  '#FFE2C4',
  '#F08C0A',
  '#F3F1EC',
  '#FCFBF8',
  '#21201E',
  '#F5FF97',
  'rgba(75, 68, 43, 0.5)',
  'hsla(223.81, 0%, 100%, 0)',
  'hsla(223.81, 0%, 100%, 0.25)',
  'hsla(223.81, 0%, 100%, 0.5)',
  'hsla(223.81, 0%, 100%, 0.75)',
  'hsla(357.96, 57.5%, 51.87%, 0)',
  'hsla(357.96, 57.5%, 51.87%, 0.25)',
  'hsla(357.96, 57.5%, 51.87%, 0.5)',
  'hsla(357.96, 57.5%, 51.87%, 0.75)',
  'hsla(143.56, 58.97%, 40.26%, 0)',
  'hsla(143.56, 58.97%, 40.26%, 0.25)',
  'hsla(143.56, 58.97%, 40.26%, 0.5)',
  'hsla(143.56, 58.97%, 40.26%, 0.75)',
  'hsla(26.99, 64.42%, 43.64%, 0)',
  'hsla(26.99, 64.42%, 43.64%, 0.25)',
  'hsla(26.99, 64.42%, 43.64%, 0.5)',
  'hsla(26.99, 64.42%, 43.64%, 0.75)',
  'hsla(197.21, 45.32%, 47.71%, 0)',
  'hsla(197.21, 45.32%, 47.71%, 0.25)',
  'hsla(197.21, 45.32%, 47.71%, 0.5)',
  'hsla(197.21, 45.32%, 47.71%, 0.75)',
  'hsla(223.81, 0%, 52.62%, 0)',
  'hsla(223.81, 0%, 52.62%, 0.25)',
  'hsla(223.81, 0%, 52.62%, 0.5)',
  'hsla(223.81, 0%, 52.62%, 0.75)',
  'transparent',
  '#FAF9F8',
  '#F5F4F1',
  '#010222',
  '#7E7C79',
  '#D5CFC9',
  '#0E173B',
  '#EB6B6B',
  '#B84A4A',
  '#FFEEED',
  '#B55007',
]

const ks = [
'background0',
'background025',
'background05',
'background075',
'color1',
'color2',
'color3',
'color4',
'color5',
'color6',
'color7',
'color8',
'color9',
'color10',
'color11',
'color12',
'color13',
'color0',
'color025',
'color05',
'color075',
'background',
'backgroundHover',
'backgroundPress',
'backgroundFocus',
'borderColor',
'borderColorHover',
'borderColorPress',
'borderColorFocus',
'color',
'colorHover',
'colorPress',
'colorFocus',
'colorTransparent',
'placeholderColor',
'outlineColor',
'textSecondary',
'backgroundSecondary',
'backgroundTertiary',
'groupedPrimary',
'groupedSecondary',
'strokePrimary',
'cream1',
'cream2',
'cream3',
'cream4',
'cream5',
'cream6',
'cream7',
'cream8',
'cream9',
'cream10',
'cream11',
'cream12',
'cream13',
'gray1',
'gray2',
'gray3',
'gray4',
'gray5',
'gray6',
'gray7',
'gray8',
'gray9',
'gray10',
'gray11',
'gray12',
'gray13',
'green1',
'green2',
'green3',
'green4',
'green5',
'green6',
'green7',
'green8',
'green9',
'green10',
'green11',
'green12',
'green13',
'lightblue1',
'lightblue2',
'lightblue3',
'lightblue4',
'lightblue5',
'lightblue6',
'lightblue7',
'lightblue8',
'lightblue9',
'lightblue10',
'lightblue11',
'lightblue12',
'lightblue13',
'limegreen1',
'limegreen2',
'limegreen3',
'limegreen4',
'limegreen5',
'limegreen6',
'limegreen7',
'limegreen8',
'limegreen9',
'limegreen10',
'limegreen11',
'limegreen12',
'limegreen13',
'navy1',
'navy2',
'navy3',
'navy4',
'navy5',
'navy6',
'navy7',
'navy8',
'navy9',
'navy10',
'navy11',
'navy12',
'navy13',
'orange1',
'orange2',
'orange3',
'orange4',
'orange5',
'orange6',
'orange7',
'orange8',
'orange9',
'orange10',
'orange11',
'orange12',
'orange13',
'red1',
'red2',
'red3',
'red4',
'red5',
'red6',
'red7',
'red8',
'red9',
'red10',
'red11',
'red12',
'red13',
'shadowColor',
'shadowColorHover',
'shadowColorPress',
'shadowColorFocus',
'navy',
'lightblue',
'cream',
'limegreen',
'strokeSecondary',
'strokeTertiary',
'textTertiary',
'textDefault',
'textSubtle',
'textMuted',
'textInverse',
'textBrand',
'textBrandStrong',
'textAccent',
'textAccentStrong',
'textPositive',
'textPositiveStrong',
'textNegative',
'textNegativeStrong',
'textWarning',
'textWarningStrong',
'iconDefault',
'iconSubtle',
'iconMuted',
'iconInverse',
'iconBrand',
'iconBrandStrong',
'iconAccent',
'iconAccentStrong',
'iconPositive',
'iconPositiveStrong',
'iconNegative',
'iconNegativeStrong',
'iconWarning',
'iconWarningStrong',
'borderDefault',
'borderDefaultHover',
'borderStrong',
'borderStrongHover',
'borderIntense',
'borderIntenseHover',
'borderInverse',
'borderBrand',
'borderBrandHover',
'borderBrandStrong',
'borderBrandStrongHover',
'borderAccent',
'borderAccentHover',
'borderAccentStrong',
'borderAccentStrongHover',
'borderPositive',
'borderPositiveHover',
'borderPositiveStrong',
'borderPositiveStrongHover',
'borderNegative',
'borderNegativeHover',
'borderNegativeStrong',
'borderNegativeStrongHover',
'borderWarning',
'borderWarningHover',
'borderWarningStrong',
'borderWarningStrongHover',
'bgBrand',
'bgBrandHover',
'bgBrandStrong',
'bgBrandStrongHover',
'bgAccent',
'bgAccentHover',
'bgAccentStrong',
'bgAccentStrongHover',
'bgPositive',
'bgPositiveHover',
'bgPositiveStrong',
'bgPositiveStrongHover',
'bgNegative',
'bgNegativeHover',
'bgNegativeStrong',
'bgNegativeStrongHover',
'bgWarning',
'bgWarningHover',
'bgWarningStrong',
'bgWarningStrongHover',
'surface0',
'surface0Hover',
'surface1',
'surface1Hover',
'surface2',
'surface2Hover',
'surfaceStrong',
'surfaceStrongHover',
'bgDisabled',
'bgDisabledSubtle',
'utilityStar',
'utilityGrellow',
'utilityOverlayDark',
'utilityOverlayMedium',
'utilityOverlayLight']


const n1 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 20],[26, 21],[27, 21],[28, 22],[29, 23],[30, 23],[31, 23],[32, 23],[33, 17],[34, 14],[35, 20],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9],[42, 24],[43, 25],[44, 26],[45, 27],[46, 28],[47, 6],[48, 29],[49, 30],[50, 31],[51, 32],[52, 33],[53, 34],[54, 35],[55, 24],[56, 36],[57, 37],[58, 38],[59, 39],[60, 40],[61, 41],[62, 42],[63, 43],[64, 44],[65, 45],[66, 46],[67, 47],[68, 24],[69, 48],[70, 49],[71, 50],[72, 51],[73, 52],[74, 53],[75, 54],[76, 55],[77, 56],[78, 57],[79, 58],[80, 59],[81, 24],[82, 60],[83, 61],[84, 62],[85, 63],[86, 64],[87, 65],[88, 66],[89, 67],[90, 68],[91, 69],[92, 70],[93, 71],[94, 24],[95, 72],[96, 73],[97, 74],[98, 75],[99, 76],[100, 77],[101, 78],[102, 79],[103, 80],[104, 81],[105, 82],[106, 83],[107, 24],[108, 84],[109, 85],[110, 86],[111, 87],[112, 13],[113, 88],[114, 89],[115, 90],[116, 91],[117, 92],[118, 93],[119, 94],[120, 24],[121, 95],[122, 96],[123, 97],[124, 98],[125, 99],[126, 100],[127, 101],[128, 102],[129, 103],[130, 104],[131, 105],[132, 106],[133, 24],[134, 107],[135, 108],[136, 109],[137, 110],[138, 111],[139, 112],[140, 113],[141, 114],[142, 115],[143, 116],[144, 117],[145, 118],[146, 119],[147, 119],[148, 120],[149, 120],[150, 121],[151, 122],[152, 123],[153, 124],[154, 125],[155, 123],[156, 126],[157, 23],[158, 127],[159, 128],[160, 129],[161, 130],[162, 131],[163, 132],[164, 133],[165, 134],[166, 135],[167, 136],[168, 137],[169, 138],[170, 139],[171, 23],[172, 127],[173, 128],[174, 129],[175, 130],[176, 131],[177, 132],[178, 133],[179, 134],[180, 135],[181, 136],[182, 137],[183, 138],[184, 139],[185, 20],[186, 21],[187, 140],[188, 127],[189, 22],[190, 23],[191, 129],[192, 141],[193, 142],[194, 143],[195, 130],[196, 144],[197, 145],[198, 146],[199, 147],[200, 142],[201, 143],[202, 134],[203, 131],[204, 148],[205, 149],[206, 150],[207, 151],[208, 152],[209, 153],[210, 154],[211, 155],[212, 156],[213, 157],[214, 157],[215, 141],[216, 158],[217, 159],[218, 145],[219, 160],[220, 156],[221, 157],[222, 142],[223, 143],[224, 161],[225, 162],[226, 149],[227, 163],[228, 164],[229, 165],[230, 153],[231, 166],[232, 167],[233, 20],[234, 168],[235, 167],[236, 129],[237, 167],[238, 22],[239, 169],[240, 21],[241, 20],[242, 153],[243, 170],[244, 171],[245, 119],[246, 120]])
const n2 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 9],[26, 13],[27, 13],[28, 13],[29, 15],[30, 13],[31, 15],[32, 13],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n3 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 107],[6, 108],[7, 109],[8, 110],[9, 111],[10, 112],[11, 113],[12, 114],[13, 115],[14, 116],[15, 117],[16, 118],[17, 176],[18, 177],[19, 178],[20, 179],[21, 24],[22, 175],[23, 107],[24, 107],[25, 117],[26, 118],[27, 118],[28, 118],[29, 118],[30, 117],[31, 118],[32, 117],[33, 177],[34, 117],[35, 178],[36, 117]])
const n4 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 48],[6, 49],[7, 50],[8, 51],[9, 52],[10, 53],[11, 54],[12, 55],[13, 56],[14, 57],[15, 58],[16, 59],[17, 180],[18, 181],[19, 182],[20, 183],[21, 24],[22, 175],[23, 48],[24, 48],[25, 58],[26, 59],[27, 59],[28, 59],[29, 59],[30, 58],[31, 59],[32, 58],[33, 181],[34, 58],[35, 182],[36, 58]])
const n5 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 95],[6, 96],[7, 97],[8, 98],[9, 99],[10, 100],[11, 101],[12, 102],[13, 103],[14, 104],[15, 105],[16, 106],[17, 184],[18, 185],[19, 186],[20, 187],[21, 24],[22, 175],[23, 95],[24, 95],[25, 105],[26, 106],[27, 106],[28, 106],[29, 106],[30, 105],[31, 106],[32, 105],[33, 185],[34, 105],[35, 186],[36, 105]])
const n6 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 60],[6, 61],[7, 62],[8, 63],[9, 64],[10, 65],[11, 66],[12, 67],[13, 68],[14, 69],[15, 70],[16, 71],[17, 188],[18, 189],[19, 190],[20, 191],[21, 24],[22, 175],[23, 60],[24, 60],[25, 70],[26, 71],[27, 71],[28, 71],[29, 71],[30, 70],[31, 71],[32, 70],[33, 189],[34, 70],[35, 190],[36, 70]])
const n7 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 36],[6, 37],[7, 38],[8, 39],[9, 40],[10, 41],[11, 42],[12, 43],[13, 44],[14, 45],[15, 46],[16, 47],[17, 192],[18, 193],[19, 194],[20, 195],[21, 24],[22, 175],[23, 36],[24, 36],[25, 46],[26, 47],[27, 47],[28, 47],[29, 47],[30, 46],[31, 47],[32, 46],[33, 193],[34, 46],[35, 194],[36, 46]])
const n8 = t([[29, 14],[30, 13],[31, 14],[32, 13]])
const n9 = t([[29, 13],[30, 13],[31, 13],[32, 13],[25, 13],[26, 13],[28, 13],[27, 13]])
const n10 = t([[29, 116],[30, 115],[31, 116],[32, 115],[25, 115],[26, 115],[28, 115],[27, 115]])
const n11 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 13],[22, 11],[23, 13],[24, 11],[25, 13],[26, 13],[27, 11],[28, 12],[29, 4],[30, 3],[31, 6],[32, 6],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n12 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 107],[6, 108],[7, 109],[8, 110],[9, 111],[10, 112],[11, 113],[12, 114],[13, 115],[14, 116],[15, 117],[16, 118],[17, 176],[18, 177],[19, 178],[20, 179],[21, 116],[22, 113],[23, 116],[24, 113],[25, 116],[26, 115],[27, 113],[28, 114],[29, 24],[30, 175],[31, 108],[32, 108],[33, 177],[34, 117],[35, 178],[36, 117],[37, 107],[38, 108],[39, 109],[40, 110],[41, 111]])
const n13 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 48],[6, 49],[7, 50],[8, 51],[9, 52],[10, 53],[11, 54],[12, 55],[13, 56],[14, 57],[15, 58],[16, 59],[17, 180],[18, 181],[19, 182],[20, 183],[21, 57],[22, 54],[23, 57],[24, 54],[25, 57],[26, 56],[27, 54],[28, 55],[29, 24],[30, 175],[31, 49],[32, 49],[33, 181],[34, 58],[35, 182],[36, 58],[37, 48],[38, 49],[39, 50],[40, 51],[41, 52]])
const n14 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 95],[6, 96],[7, 97],[8, 98],[9, 99],[10, 100],[11, 101],[12, 102],[13, 103],[14, 104],[15, 105],[16, 106],[17, 184],[18, 185],[19, 186],[20, 187],[21, 104],[22, 101],[23, 104],[24, 101],[25, 104],[26, 103],[27, 101],[28, 102],[29, 24],[30, 175],[31, 96],[32, 96],[33, 185],[34, 105],[35, 186],[36, 105],[37, 95],[38, 96],[39, 97],[40, 98],[41, 99]])
const n15 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 60],[6, 61],[7, 62],[8, 63],[9, 64],[10, 65],[11, 66],[12, 67],[13, 68],[14, 69],[15, 70],[16, 71],[17, 188],[18, 189],[19, 190],[20, 191],[21, 69],[22, 66],[23, 69],[24, 66],[25, 69],[26, 68],[27, 66],[28, 67],[29, 24],[30, 175],[31, 61],[32, 61],[33, 189],[34, 70],[35, 190],[36, 70],[37, 60],[38, 61],[39, 62],[40, 63],[41, 64]])
const n16 = t([[0, 172],[1, 173],[2, 174],[3, 175],[4, 24],[5, 36],[6, 37],[7, 38],[8, 39],[9, 40],[10, 41],[11, 42],[12, 43],[13, 44],[14, 45],[15, 46],[16, 47],[17, 192],[18, 193],[19, 194],[20, 195],[21, 45],[22, 42],[23, 45],[24, 42],[25, 45],[26, 44],[27, 42],[28, 43],[29, 24],[30, 175],[31, 37],[32, 37],[33, 193],[34, 46],[35, 194],[36, 46],[37, 36],[38, 37],[39, 38],[40, 39],[41, 40]])
const n17 = t([[21, 129],[22, 167],[23, 167],[24, 167],[29, 23],[30, 23],[31, 23],[32, 23],[25, 20],[26, 21],[27, 21],[28, 22],[34, 128],[35, 22],[-1, 196],[-1, 197],[-1, 198],[-1, 129],[-1, 199],[36, 200],[-1, 140],[-1, 125],[-1, 201],[-1, 121],[-1, 202],[-1, 124],[-1, 134],[-1, 156],[-1, 203],[-1, 204],[-1, 205],[-1, 153],[-1, 206],[-1, 164]])

type ThemeNames =
 | 'light'
 | 'light_granted'
 | 'light_red'
 | 'light_green'
 | 'light_orange'
 | 'light_lightblue'
 | 'light_gray'
 | 'light_alt1'
 | 'light_alt2'
 | 'light_red_alt2'
 | 'v2'

export const themes: Record<ThemeNames, Theme> = {
  light: n1,
  light_granted: n2,
  light_red: n3,
  light_green: n4,
  light_orange: n5,
  light_lightblue: n6,
  light_gray: n7,
  light_alt1: n8,
  light_alt2: n9,
  light_red_alt2: n10,
  light_Button: n11,
  light_granted_Button: n11,
  light_red_Button: n12,
  light_green_Button: n13,
  light_orange_Button: n14,
  light_lightblue_Button: n15,
  light_gray_Button: n16,
  v2: n17,
}
